import { render, staticRenderFns } from "./EditNotice.vue?vue&type=template&id=3a6be200&scoped=true"
import script from "./EditNotice.vue?vue&type=script&lang=js"
export * from "./EditNotice.vue?vue&type=script&lang=js"
import style0 from "./EditNotice.vue?vue&type=style&index=0&id=3a6be200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6be200",
  null
  
)

export default component.exports